export default __webpack_public_path__ + "static/media/a009-ransomware-02.d4010c57.svg";